"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChrField = void 0;
const EditorFieldBase_1 = require("./EditorFieldBase");
class ChrField extends EditorFieldBase_1.EditorFieldBase {
}
exports.ChrField = ChrField;
